import { cn } from "@/lib/utils/cn";

type Status = "todo" | "pending" | "done" | "rejected";

const styles: Record<Status, string> = {
  todo: "bg-[#F1F4EF] text-navy",
  pending: "bg-hay text-[#7A5A00]",
  done: "bg-[#DCF1E4] text-forest",
  rejected: "bg-[#FEE2E2] text-[#B91C1C]",
};

const labels: Record<Status, string> = {
  todo: "do zrobienia",
  pending: "🕒 czeka",
  done: "✓ zrobione",
  rejected: "✕ odrzucone",
};

export function StatusBadge({
  status,
  className,
  children,
}: {
  status: Status;
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[12px] font-semibold leading-none",
        styles[status],
        className,
      )}
    >
      {children ?? labels[status]}
    </span>
  );
}
